import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import eventTypesApi from '../api/eventTypes.api';
import { DefaultErrorMessage } from '../displayStrings';
export const useEventTypes = () => {
  const { showToast } = useToastProvider();
  const { companyId } = useCurrentUser();

  return useQuery('eventTypesList', () => eventTypesApi.getEventTemplates(companyId), {
    enabled: !!companyId,
    onError: () => {
      showToast({
        title: 'Could not retrieve event types',
        description: DefaultErrorMessage,
        status: 'error',
      });
    },
  });
};
